import { useHasPermission } from "@/hooks/permissions/use-has-permission";
import {
	TrackModeContext,
	TrackModeEnum,
} from "@/providers/track-mode.provider";
import React, { useContext, useEffect } from "react";
// @ts-ignore
import { Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom"; // use this package for navs

const XmlMessagesLink = ({ to }: { to: string }) => {
	if (!useHasPermission("Broker.ReadXmlMessages")) return null;
	return (
		<Nav.Link as={Link} to={to}>
			XML Messages
		</Nav.Link>
	);
};

const CustomNavbar = () => {
	const { trackMode, setTrackMode } = useContext(TrackModeContext);
	const navigate = useNavigate();
	const location = useLocation();
	useEffect(() => {
		if (location.pathname === "/") navigate("/choose-mode");
		if (location.pathname.includes("/ladle-track"))
			setTrackMode(TrackModeEnum.LADLE_TRACK);
		if (location.pathname.includes("/tundish-track"))
			setTrackMode(TrackModeEnum.TUNDISH_TRACK);
	}, []);

	switch (trackMode) {
		case TrackModeEnum.LADLE_TRACK:
			return (
				<>
					<Nav.Link as={Link} to="/ladle-track/plant-overview">
						Plant Overview
					</Nav.Link>
					<Nav.Link as={Link} to="/ladle-track/ladle-overview">
						Ladle Overview
					</Nav.Link>
					<Nav.Link as={Link} to="/ladle-track/ladle-24-h-log">
						Ladle 24h Log
					</Nav.Link>
					<Nav.Link as={Link} to="/ladle-track/ladle-details">
						Ladle Details
					</Nav.Link>
					<Nav.Link as={Link} to="/ladle-track/campaigns">
						Tasks List
					</Nav.Link>
					<Nav.Link as={Link} to="/ladle-track/ladle-campaigns">
						Ladle Campaigns
					</Nav.Link>

					{/* <Nav.Link as={Link} to="/broker">
						Broker
					</Nav.Link> */}
					<XmlMessagesLink to="/ladle-track/xml-messages" />
				</>
			);
		case TrackModeEnum.TUNDISH_TRACK:
			return (
				<>
					<Nav.Link as={Link} to="/tundish-track/plant-overview">
						Plant Overview
					</Nav.Link>
					<Nav.Link as={Link} to="/tundish-track/tundish-overview">
						Tundish Overview
					</Nav.Link>
					<Nav.Link as={Link} to="/tundish-track/build-log">
						Build Log
					</Nav.Link>
					{/*<Nav.Link as={Link} to="/tundish-track/details">Tundish Details</Nav.Link>*/}

					<NavDropdown title="Tundish Details" id="basic-nav-dropdown">
						<NavDropdown.Item as={Link} to="/tundish-track/details">
							Details
						</NavDropdown.Item>
						<NavDropdown.Divider />
						<NavDropdown.Item
							as={Link}
							to="/tundish-track/details/special-components/lids"
						>
							Lids Details
						</NavDropdown.Item>
						<NavDropdown.Item
							as={Link}
							to="/tundish-track/details/special-components/nqc-system"
						>
							NQC System Details
						</NavDropdown.Item>
						<NavDropdown.Item
							as={Link}
							to="/tundish-track/details/special-components/sert-mech"
						>
							SERT Mech Details
						</NavDropdown.Item>
						<NavDropdown.Item
							as={Link}
							to="/tundish-track/details/special-components/permanent-lining"
						>
							Permanent Lining
						</NavDropdown.Item>
					</NavDropdown>

					<NavDropdown title="Reports" id="reports-nav-dropdown">
						<NavDropdown.Item
							as={Link}
							to="/tundish-track/reports/tundish-track"
						>
							Tundish Track
						</NavDropdown.Item>
						<NavDropdown.Item as={Link} to="/tundish-track/reports/dry-vibe">
							Dry Vibe
						</NavDropdown.Item>
					</NavDropdown>

					{/* <Nav.Link as={Link} to="/broker">
						Broker
					</Nav.Link> */}
					<XmlMessagesLink to="/tundish-track/xml-messages" />
				</>
			);
		default:
			return <></>;
	}
};

export { CustomNavbar };
